const getSupplierPhone3 = ({ business, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  return business['Company Contact'] && business['Company Contact']['Phone Number']
    ? business['Company Contact']['Phone Number'].replace('+1 ', '').replace(/[\s()-]/g, '').slice(6, 10) : null;
};

export default getSupplierPhone3;



// WEBPACK FOOTER //
// ./src/utils/print/getSupplierPhone3.js